import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IEstimateGroupData } from "common/records/EstimateGroup";
import { Nullable } from "common/types";

export const RECEIVE_ESTIMATE_GROUP = "@estimateGroups/RECEIVE_ESTIMATE_GROUP";
export const UPDATE_ESTIMATE_GROUP_TOTALS = "@estimateGroups/UPDATE_ESTIMATE_GROUP_TOTALS";
export const DECREMENT_ESTIMATE_GROUP_UNSAVED_ID = "@estimateGroups/DECREMENT_ESTIMATE_GROUP_UNSAVED_ID";
export const SET_ESTIMATE_GROUP_BY_ID = "@estimateGroups/SET_ESTIMATE_GROUP_BY_ID";
export const DUPLICATE_ESTIMATE_GROUP = "@estimateGroups/DUPLICATE_ESTIMATE_GROUP";
export const COPY_ESTIMATE_GROUP_TO_LAST_SAVED = "@estimateGroups/COPY_ESTIMATE_GROUP_TO_LAST_SAVED";
export const START_RENAMING_GROUP = "@estimateGroups/START_RENAMING_GROUP";
export const UPDATE_RENAMING_GROUP_DRAFT_NAME = "@estimateGroups/UPDATE_RENAMING_GROUP_DRAFT_NAME";
export const STOP_RENAMING_GROUP = "@estimateGroups/STOP_RENAMING_GROUP";

export const EstimateGroupActions = {
  receiveEstimateGroup: (estimateGroup: Partial<IEstimateGroupData>) =>
    createAction(RECEIVE_ESTIMATE_GROUP, { estimateGroup }),
  updateTotals: (estimateGroupId: Nullable<number>) => createAction(UPDATE_ESTIMATE_GROUP_TOTALS, { estimateGroupId }),
  decrementUnsavedId: () => createAction(DECREMENT_ESTIMATE_GROUP_UNSAVED_ID),
  setEstimateGroupById: (estimateGroupId: number, estimateGroup: Partial<IEstimateGroupData>) =>
    createAction(SET_ESTIMATE_GROUP_BY_ID, { estimateGroupId, estimateGroup }),
  /**
   * Duplicates an estimate group and its line items to a new estimate
   *
   * @param sourceGroupId The id of the group to duplicate
   * @param targetEstimateId The id of the estimate to add the duplicated group to
   */
  duplicateEstimateGroup: (sourceGroupId: number, targetEstimateId: number) =>
    createAction(DUPLICATE_ESTIMATE_GROUP, { sourceGroupId, targetEstimateId }),
  copyEstimateGroupToLastSaved: (estimateGroupId: number) =>
    createAction(COPY_ESTIMATE_GROUP_TO_LAST_SAVED, { estimateGroupId }),
  startRenamingGroup: (groupId: number, draftName: string) =>
    createAction(START_RENAMING_GROUP, { groupId, draftName }),
  updateRenamingGroupDraftName: (draftName: string) => createAction(UPDATE_RENAMING_GROUP_DRAFT_NAME, { draftName }),
  stopRenamingGroup: () => createAction(STOP_RENAMING_GROUP),
};

export type EstimateGroupActions = ActionsUnion<typeof EstimateGroupActions>;
